import styles from './WarningField.module.scss'

interface IProps {
  value: string
  isShow: boolean
}

export const WarningField = ({ value, isShow }: IProps) => {
  const isMandatory = Number(value || 0) < 0

  return (
    <div className={styles.mandatory}>
      {isShow && isMandatory && <i className={'kbase kbase-warning-alt'} />}
    </div>
  )
}
